import React, { useEffect, useState, useCallback, Suspense } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { QueryHookParam, useQueryDummyHook } from '@utils/hook/useQueryHook';
import { CreateAsoOption } from '@classes/options/chart/aso/aso';
import { PieChartDataModel } from '@models/highChartsModel';
import { ScoreBarType } from '@models/aso/aso';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));
const ScoreBar = React.lazy(() => import('@components/template/aso/score/scoreBar'));
const ScorePie = React.lazy(() => import('@components/template/aso/score/scorePie'));
const DailyScore = React.lazy(() => import('@components/template/aso/score/dailyScore'));

const Aso = () => {
  const { selectedAppInfo } = useSelector((state: RootState) => state.LAYOUT);

  // chartData
  const [scoreBarChartData, setScoreBarChartData] = useState<ScoreBarType[]>(null);
  const [scorePieChartData, setScorePieChartData] = useState<PieChartDataModel>(null);
  const [dailyChartData, setDailyChartData] = useState(null);

  // chartDataOption
  const _option = new CreateAsoOption();

  // Rosetta Score 차트 데이터
  const scoreParams: QueryHookParam = {
    key: ['rosettaScore', selectedAppInfo?.appId, selectedAppInfo?.provider_type],
    url: '/api/app/asoScoreMain.json',
    params: { appId: selectedAppInfo?.appId, type: selectedAppInfo?.provider_type },
    method: 'GET',
    enabled: selectedAppInfo !== null,
  };
  const { data: scoreData, isLoading: isLoadingScore } = useQueryDummyHook(scoreParams);

  // Rosetta Daily 차트 데이터
  const dailyParams: QueryHookParam = {
    key: ['rosettaDailyData', selectedAppInfo?.appId, selectedAppInfo?.provider_type],
    url: '/api/app/asoScoreDailyList.json',
    params: { appId: selectedAppInfo?.appId, type: selectedAppInfo?.provider_type },
    method: 'GET',
    enabled: selectedAppInfo !== null,
  };
  const { data: dailyData, isLoading: isLoadingDaily } = useQueryDummyHook(dailyParams);

  // Rosetta Score 차트 데이터 옵션처리
  useEffect(() => {
    if (scoreData) {
      setScoreBarChartData(_option.scoreBar(scoreData));
      setScorePieChartData(_option.scorePie(scoreData));
    }
  }, [scoreData]);

  // Rosetta Daily 차트 데이터 옵션처리
  useEffect(() => {
    if (dailyData) {
      setDailyChartData(_option.dailyScore(dailyData));
    }
  }, [dailyData]);

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <div className="chart-box">
        <h2 className="chart-tit">Rosetta Score</h2>
        <div className="r-score">
          <Suspense fallback={<LoaderComponent />}>
            <ScoreBar chartData={scoreBarChartData} />
          </Suspense>
          <Suspense fallback={<LoaderComponent />}>
            <ScorePie chartData={scorePieChartData} isLoading={isLoadingScore} />
          </Suspense>
        </div>
      </div>
      <Suspense fallback={<LoaderComponent />}>
        <DailyScore chartData={dailyChartData} isLoading={isLoadingDaily} />
      </Suspense>
    </>
  );
};

export default Aso;
